import { useState } from 'react'
import axios from 'axios'
import { buildWorkCountApiUrl } from '@pc/components/Works/Panel/util/workSearchApi'
import type { SearchParamsAttributes } from '@pc/components/Works/Panel/type'

const useWorksCount = () => {
  const [worksCount, setWorksCount] = useState(0)

  const updateCountFromParams = (mergedParams: SearchParamsAttributes) => {
    const endPoint: string = buildWorkCountApiUrl(mergedParams)
    axios
      .get(endPoint)
      .then((res) => {
        setWorksCount(res.data as number)
      })
      .catch((err) => {
        console.log(err.message)
      })
  }

  return { worksCount, updateCountFromParams }
}

export default useWorksCount
